import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
export var HeaderKit = function (_a) {
  var canIndex = _a.canIndex,
    title = _a.title,
    description = _a.description;
  var location = useLocation();
  var index = 'noindex,follow';
  var titleEl = /*#__PURE__*/React.createElement("title", null, title || "");
  var descriptionEl = /*#__PURE__*/React.createElement("meta", {
    name: 'description',
    content: description || ""
  });
  var canonical = /*#__PURE__*/React.createElement("link", {
    rel: 'canonical',
    href: window.location.origin + location.pathname
  });
  if (canIndex) {
    index = 'index,follow';
  }
  // Kit domains without own domain never get indexed
  if (window.location.host === 'call.beianrufsex.com') {
    index = 'noindex,follow';
  }
  // Noindexed pages should never have a canonical url?!
  if (index.indexOf('noindex') !== -1) {
    canonical = null;
  }
  return /*#__PURE__*/React.createElement(Helmet, null, titleEl, descriptionEl, /*#__PURE__*/React.createElement("meta", {
    name: 'robots',
    content: index
  }), canonical);
};